import { render, staticRenderFns } from "./Polaroid.vue?vue&type=template&id=0ee1d3f3&scoped=true&"
var script = {}
import style0 from "./Polaroid.vue?vue&type=style&index=0&id=0ee1d3f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee1d3f3",
  null
  
)

export default component.exports